import { ConfigurableExportField } from 'shared/react-admin/Export/ExportEditButton/ExportEditButton';

export const EXPORT_FIELDS_ORDERS: ConfigurableExportField[] = [
  {
    index: '0',
    source: 'id',
    labelKey: 'app.table.idKubera',
  },
  {
    index: '1',
    source: 'createdAt',
    labelKey: 'app.table.creationTime',
  },
  {
    index: '2',
    source: 'updatedAt',
    labelKey: 'app.table.updateTime',
  },
  {
    index: '3',
    source: 'amount',
    labelKey: 'app.table.amount',
  },
  {
    index: '4',
    source: 'currency',
    labelKey: 'app.table.currency',
  },
  {
    index: '5',
    source: 'status',
    labelKey: 'app.table.status',
  },
  {
    index: '6',
    source: 'type',
    labelKey: 'app.table.direction',
  },
  {
    index: '7',
    source: 'customer',
    labelKey: 'app.table.client',
  },
  {
    index: '8',
    source: 'customerAccount',
    labelKey: 'app.table.clientData',
  },
  {
    index: '9',
    source: 'method',
    labelKey: 'app.table.method',
  },
  {
    index: '10',
    source: 'gateway',
    labelKey: 'app.table.gateway',
  },
  {
    index: '11',
    source: 'merchant',
    labelKey: 'app.table.merchant',
  },
  {
    index: '12',
    source: 'orderProviderExternalError',
    labelKey: 'app.table.declineReason',
  },
  {
    index: '13',
    source: 'merchantReference',
    labelKey: 'app.table.idMerchant',
  },
  {
    index: '14',
    source: 'providerReferenceId',
    labelKey: 'app.table.idProvider',
  },
  {
    index: '15',
    source: 'provider',
    labelKey: 'app.table.provider',
  },
];
